export default __webpack_public_path__ + "i18n/ko.a1b4a1f79c80a2d30674cfd2cf1f038d.json";